<template>
    <ListingTableFilter
        :filter="filter"
        :valuesHumanized="appliedFilterLabels"
        :filterConfig="filterConfig"
        @updateFilter="updateFilter"
        @updateVisibility="updateVisibility"
        @removeFilter="removeFilter"
    >
        <template #filterDropdownContent>
            <!-- We need to add an empty option to force the content to be displayed  -->
            <CompassDropdownOption
                value="emptyOption"
                label="emptyOption"
                class="listing-filter-dropdown-search-empty"
            />
            <CompassInput
                v-model="searchValue"
                :placeholder="$t.__('common.labels.search')"
                class="listing-filter-dropdown-search-input"
                @change="updateFilter"
            >
                <template #suffix>
                    <CompassIcon
                        v-show="hasSearchValue"
                        icon="close"
                        type="primary"
                        class="listing-filter-dropdown-search-reset"
                        @click="clearSearch"
                    />
                </template>
            </CompassInput>
        </template>
    </ListingTableFilter>
</template>

<script>
import ListingTableFilter from 'vcomponents/common/listing/filters/ListingTableFilter.vue';

export default {
    components: { ListingTableFilter },
    props: {
        filter: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            searchValue: '',
        };
    },
    computed: {
        appliedFilterLabels() {
            return this.filter.optionsSelected.join();
        },
        filterConfig() {
            return {
                isVisible: this.filter.displayDropdown,
                actions: [
                    {
                        label: this.$t.__('common.actions.apply'),
                        callback: this.updateFilter,
                    },
                ],
                dropdownClass: 'listing-filter-dropdown-search',
            };
        },
        hasSearchValue() {
            return this.searchValue.length > 0;
        },
    },
    watch: {
        'filter.displayDropdown': function (value) {
            if (value) {
                this.searchValue = this.appliedFilterLabels;
            }
        },
    },
    methods: {
        updateFilter() {
            if (this.searchValue === '') {
                this.removeFilter();
            } else {
                this.$emit('updateFilter', [this.searchValue]);
                this.updateVisibility(false);
            }
        },
        removeFilter() {
            this.$emit('removeFilter', this.filter.code);
        },
        updateVisibility(visibility) {
            this.$emit('update:displayDropdown', visibility);
        },
        clearSearch() {
            this.searchValue = '';
        },
    },
};
</script>

<style lang="scss">
.listing-filter-dropdown-search {
    max-width: 220px;

    &-empty.compass-dropdown-option {
        display: none;
    }

    &-input {
        width: 100%;
    }

    &-reset {
        cursor: pointer;
    }
}
</style>
